import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/blocks.action'
import { destroyTaskBlock } from 'api/administration/blocks/Destroy'
import lessonBlocksList from 'api/administration/blocks/List'
import I18n from 'i18n'
import { SuccessToast, ErrorToast } from 'components/ui/toast/toastsTemplates'

async function getList(lessonId: number) {
  return await lessonBlocksList(lessonId)
}

async function handleDestroyTaskBlock(taskBlockId: number) {
  return await destroyTaskBlock(taskBlockId)
}

function* destroyTaskBlockEffectSaga(action: any) {
  try {
    const {
      payload: { taskBlockId, lessonId },
    } = action
    yield call(handleDestroyTaskBlock, taskBlockId)
    const data = yield call(getList, lessonId)
    yield put(fromActions.Actions.getLessonBlocksListSuccess(data))
    SuccessToast(I18n.t('administration.toastMessages.deleteSuccess'))
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* destroyTaskBlockWatcherSaga() {
  yield takeLatest(fromActions.DESTROY_TASK_BLOCK, destroyTaskBlockEffectSaga)
}
